// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"15":"fb788fb2","370":"2ae63053","425":"4501a9c5","480":"ecfd0962","643":"a76b97da","870":"ce2402fb","904":"ecfd0962","982":"ecfd0962"}[chunkId] + ".chunk.css";
};